import {ColorSchemeType, Flag} from 'platform/components';
import {useFormatPercentage} from 'platform/locale';
import {match, Pattern} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {SourcingVehicleResponseBody} from '@dms/api/core';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {MarketSituationAndPriceDynamicsTooltip} from '../MarketSituationAndPriceDynamicsTooltip/MarketSituationAndPriceDynamicsTooltip';

interface AttractivenessFlagProps extends TestIdProps {
  sourcingVehicle?: SourcingVehicleResponseBody | null;
}

export function AttractivenessFlag(props: AttractivenessFlagProps) {
  const formatPercentage = useFormatPercentage();
  const colorScheme = match<number | Nullish, ColorSchemeType>(
    props.sourcingVehicle?.attractivenessScore
  )
    .with(Pattern.nullish, () => 'neutral')
    .with(Pattern.number.gte(0.8), () => 'blue')
    .with(Pattern.number.gte(0.6), () => 'green')
    .with(Pattern.number.gte(0.4), () => 'yellow')
    .with(Pattern.number.gte(0.2), () => 'orange')
    .otherwise(() => 'red');

  return (
    <MarketSituationAndPriceDynamicsTooltip sourcingVehicle={props.sourcingVehicle}>
      <Flag
        label={
          isNotNil(props.sourcingVehicle?.attractivenessScore)
            ? formatPercentage(props.sourcingVehicle.attractivenessScore, 'down')
            : 'N/A'
        }
        size="small"
        colorScheme={colorScheme}
        data-testid={suffixTestId('attractivenessFlag', props)}
      />
    </MarketSituationAndPriceDynamicsTooltip>
  );
}
